
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AvailableService } from '@/features/shipment/types';
import TotalCost from '@/features/shipment/components/checkout/TotalCost.vue';
import { getPrice } from '@/features/common/helpers';
import { getCarrierLogoCode, getDisplayCarrierCode } from '@/features/common/helpers/carrier';

@Component({
  components: {
    TotalCost,
  },
})
export default class ServiceItem extends Vue {
  @Prop({ required: true }) showDetails!: boolean;

  @Prop({ required: true }) packagesCount!: number;

  get service(): AvailableService {
    return this.$store.state.shipment.selectedService;
  }

  private getPrice = getPrice;

  private getCarrierLogoCode = getCarrierLogoCode;

  private getDisplayCarrierCode = getDisplayCarrierCode;
}
